import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import { T as TouchLinkButton, a as TouchLinkAnchor } from './TouchLink.styles-D0GPtYUj.js';
import { T as TouchLinkBody } from './TouchLinkBody-D3Gm1YU4.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const TouchLink = ({
  children,
  href,
  onClick,
  taktId,
  taktValue
}) => {
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('touch-link')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(TouchLinkButton, _extends({
      onClick: onClick
    }, getDataTaktAttributes()), /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children)));
  }
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('touch-link')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(TouchLinkAnchor, _extends({
    href: href
  }, getDataTaktAttributes()), /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children)));
};
TouchLink.propTypes = {
  /**
   * Use to add a link to TouchLink.
   */
  href: PT.string,
  /**
   * Use to add a button to TouchLink.
   */
  onClick: PT.func
};
TouchLink.defaultProps = {
  href: undefined,
  onClick: undefined
};
TouchLink.displayName = 'TouchLink';

export { TouchLink as T };
//# sourceMappingURL=TouchLink-C-04tjX9.js.map
